import { groupBy, orderBy } from "lodash";
//APP
import { numeroMilhar } from "../../../../../../../utils";
import { typeInsumoAdd } from "../../../../linhaDoTempo/components/cadastro";
import { obterCodInsumo } from "../../../../linhaDoTempo/components/cadastro/components/executada/components/execucoesTable/meta";
import { Item__Atividades, ItemPropriedades, typeEmergencia } from "../../../../../../../services/atividades/GET";
import { obterNomeMediaLocal, unidade_medida_local } from "../../../../visaoGeral/components/insumosPrecisao/meta";
import { dummy_tipos_uso, extrairNumeroAposAsterisco, extrairUnidade } from "../../../../linhaDoTempo/components/cadastro/components/addInsumo/meta";
import dayjs from "dayjs";

//#region NORMALIZAR QTD
/**Normaliza quantidade para Litros ou Kg
 * 
 * `l -> L`
 * `ml -> L`
 * `kg -> Kg`
 * `g -> kg`
 * `t -> kg`
*/
export function normalizarQuantidadeRelatorio(quantidade: number, cod_medida: number) {
    //L -> L
    if (cod_medida === 1) {
        return { quantidade: quantidade, medida: 'L', desc: `${numeroMilhar(quantidade)} L` };
    }
    //mL -> L
    if (cod_medida === 2) {
        return { quantidade: quantidade / 1000, medida: 'L', desc: `${numeroMilhar(quantidade / 1000)} L` };
    }
    //KG -> KG
    if (cod_medida === 3 || cod_medida === 6) {
        if (quantidade >= 1000) {
            return { quantidade: quantidade / 1000, medida: 't', desc: `${numeroMilhar(quantidade / 1000)} t` };
        }
        return { quantidade: quantidade, medida: 'Kg', desc: `${numeroMilhar(quantidade)} Kg` };
    }
    //g -> KG
    if (cod_medida === 4) {
        if (quantidade < 1000) {
            return { quantidade: quantidade, medida: 'g', desc: `${numeroMilhar(quantidade)} g` };
        }
        return { quantidade: quantidade / 1000, medida: 'Kg', desc: `${numeroMilhar(quantidade / 1000)} Kg` };
    }
    //t -> t
    if (cod_medida === 7) {
        return { quantidade: quantidade, medida: 't', desc: `${numeroMilhar(quantidade)} t` };
    }
    //sementes 
    if (cod_medida === 9) {
        return { quantidade: quantidade, medida: 'sementes', desc: `${numeroMilhar(quantidade)} de sementes` };
    }

    return { quantidade: quantidade, medida: null, desc: `${numeroMilhar(quantidade)}` };

}

//TYPES
export type typeInsumos = {
    insumo_nome: string;
    cod_tipo: number;
    nome_tipo: string | undefined;
    cod_insumo: number;
    dosagem: number;
    quantidade: number;
    tecnologia_nome: string | undefined;
    cod_medida: number;
    nome_medida: string | undefined;
    calculo_dosagem: string;
    ordem: number;
    quantidade_insumo: string | undefined;
    doses_inoculante: number;
    tipo_fisico: string | undefined;
    cod_atividade?: number;
    porcentagem_remonte?: number;
    descricao_atv?: string;
    tipo_nome?: string;
    quantidade_insumo_normalizada?: number;
    medida_insumo_normalizada?: string;
    cod_talhao?: number;
    observacao?: string;
    area_atividade?: number; //usado apenas no relatório de insumos totalizados
}

export type typeAtvsPorTalhao = {
    cod_talhao: number;
    nome_talhao: string;
    area: number;
    lista_atividades: {
        cod: number;
        descricao: string;
        area: number;
        area_executada: number;
        cod_operacao: number;
        cod_referencia: number;
        concluido: boolean;
        dias: number;
        data_inicio: string | null;
        data_final: string | null;
        finalidades: any[];
        estadios_cultura: any[];
        observacao: string;
        porcentagem_executada: number;
        porcentagem_remonte: number;
        tipo_operacao: string;
        tipo_referencia: number;
        tipo_referencia_nome: string;
        insumos: typeInsumos[];
        patrimonios: any;
        dias_apos_plantio?: number | null;
        dias_apos_emergencia?: number | null;
        nome_atv_vinculada?: string;
        atv_is_pulverizacao: boolean;
    }[];
}

export type typeEstruturaTodasAtvs = {
    cod_propriedade: number;
    nome_propriedade: string;
    lista_atividades_por_talhao: typeAtvsPorTalhao[];
};

//#region GERAR ESTRUTURA
/**Agrupa as atividades por propriedade e por talhões, e retorna uma estrutura base para montar todos os relatórios */
export function estruturaTodasAtvs(
    data_atividades: Item__Atividades[],
    data_propriedades: ItemPropriedades[],
    data_emergencia_todos_talhoes: typeEmergencia[],
    cod_propriedade_selecionada: number,
    cod_talhao_selecionado: number,
    cod_subarea_selecionada: number,
): typeEstruturaTodasAtvs[] {

    const atvs_ativas = data_atividades.filter(i => i.delete_time === null);
    let atvs_filtradas = [];

    //#region filtros
    if (cod_propriedade_selecionada) {
        if (cod_talhao_selecionado) {
            if (cod_subarea_selecionada) {
                atvs_filtradas = atvs_ativas.filter(i => i.cod_propriedade === cod_propriedade_selecionada && i.cod_talhao === cod_subarea_selecionada);
            }
            atvs_filtradas = atvs_ativas.filter(i => i.cod_propriedade === cod_propriedade_selecionada && i.cod_talhao === cod_talhao_selecionado);
        }
        atvs_filtradas = atvs_ativas.filter(i => i.cod_propriedade === cod_propriedade_selecionada);
    }
    else {
        atvs_filtradas = atvs_ativas;
    }
    //#endregion

    //#region listas estasticas
    //@ts-ignore
    const todos_talhoes: Item__Talhao[] = (data_propriedades ?? []).flatMap(i => i.talhao);
    const mapTalhoes = new Map((todos_talhoes ?? []).map(t => [t.cod, t]));
    const mapMedidaLocais = new Map(unidade_medida_local.map(i => [i.cod, i]));
    const mapDummyTiposUso = new Map(dummy_tipos_uso.map(i => [i.cod, i]));
    const mapEmergenciaTalhoes = new Map((data_emergencia_todos_talhoes ?? []).map(e => [e.cod, e.data_emergencia_plantio]));
    //#endregion

    //#region estrutura
    const atvs_planejadas = atvs_filtradas.filter(i => i.cod_tipo === 1);

    // Dicionário de data de plantio por talhão para melhorar a performance (busca O(1))
    const mapPlantioTalhoes = new Map<number, string | null>();
    for (const pl of atvs_planejadas) {
        if (pl.cod_operacao === 100 && !mapPlantioTalhoes.has(pl.cod_talhao)) {
            mapPlantioTalhoes.set(pl.cod_talhao, pl.data_inicio);
        }
    }

    // Dicionário de descrição da atividade por código para melhorar a performance (busca O(1))
    const mapNomeAtividades = new Map<number, string>();
    for (const pl of atvs_planejadas) {
        if (!mapNomeAtividades.has(pl.cod)) {
            mapNomeAtividades.set(pl.cod, pl.descricao);
        }
    }

    const agrupar_planejadas_por_propriedade = groupBy(atvs_planejadas, 'cod_propriedade');

    function dosagemEmLitros(dosagem: number, cod_unidade_medida: number) {
        if (cod_unidade_medida === 1) { //L
            return dosagem;
        }
        if (cod_unidade_medida === 2) { //mL
            return dosagem / 1000;
        }
        return 0;
    }

    const atividades_por_propriedade: typeEstruturaTodasAtvs[] = Object.entries(agrupar_planejadas_por_propriedade).map(([cod_propriedade, lista_atvs_plan]) => {
        const agrupar_por_talhao = groupBy(lista_atvs_plan, 'cod_talhao');
        const atividades_por_talhao = Object.entries(agrupar_por_talhao).map(([cod_talhao, lista_atvs_talhao]) => {


            const lista_atividades = lista_atvs_talhao?.map(i => {

                //#region patrimonios
                //@ts-ignore
                const patrimonios = (i.andamentos ?? []).map(anda => anda.patrimonios)?.flat();
                const pulverizadora = (patrimonios ?? []).find(pat => Number(pat.capacidade_tanque) > 0 && Number(pat.vazao) > 0);
                const area_tanque = pulverizadora ? Number(pulverizadora?.capacidade_tanque) / Number(pulverizadora.vazao) : null;
                //#endregion

                //#region insumos
                const insumos = (i.andamentos ?? []).flatMap(anda => anda.insumos ?? [])?.map(insu => {
                    const cod_insumo = obterCodInsumo(insu as unknown as typeInsumoAdd);
                    const nome_medida = mapMedidaLocais.get(Number(insu.cod_medida))?.nome;
                    const cod_medida = insu?.cod_tipo === 8 ? obterCodMedidaInoculante(extrairUnidade(insu?.calculo_dosagem)) : Number(insu.cod_medida);
                    const { desc, quantidade, medida } = normalizarQuantidadeRelatorio(Number(insu.quantidade), cod_medida);
                    const no_tanque = area_tanque ? Number(area_tanque) * dosagemEmLitros(Number(insu.dosagem), Number(insu.cod_medida)) : null;
                    return {
                        insumo_nome: String(insu.insumo_nome),
                        cod_tipo: Number(insu.cod_tipo),
                        nome_tipo: mapDummyTiposUso.get(Number(insu.cod_tipo))?.nome,
                        cod_insumo: cod_insumo,
                        dosagem: Number(insu.dosagem),
                        quantidade: Number(insu.quantidade),
                        tecnologia_nome: insu?.nome_tecnologia,
                        cod_medida: Number(insu.cod_medida),
                        nome_medida: insu?.cod_tipo === 8 ? extrairUnidade(insu?.calculo_dosagem) : nome_medida,
                        calculo_dosagem: (insu.calculo_dosagem),
                        ordem: Number(insu.ordem),
                        quantidade_insumo: desc,
                        quantidade_insumo_normalizada: quantidade,
                        medida_insumo_normalizada: medida,
                        doses_inoculante: Number(insu.dosagem) / Number(extrairNumeroAposAsterisco(insu?.calculo_dosagem)),
                        tipo_fisico: obterNomeMediaLocal(Number(insu.cod_medida))?.tipo_fisico,
                        observacao: insu.observacao,
                        no_tanque: no_tanque ? numeroMilhar(no_tanque) : null,
                        composicao: insu?.composicao,
                        composicao_bioinsumo: insu?.composicao_bioinsumo,
                        classe_agronomica_nome: insu?.classe_agronomica_nome,
                        cod_classe_agronomica: insu?.cod_classe_agronomica
                    }
                });
                //#endregion

                const porcentagem_remonte: number = i.porcentagem_remonte ? Number(i.porcentagem_remonte) : 0;
                const data_plantio = mapPlantioTalhoes.get(Number(cod_talhao));
                const emergencia_talhao = mapEmergenciaTalhoes.get(Number(cod_talhao));
                const data_emergencia = emergencia_talhao ? dayjs(emergencia_talhao) : (data_plantio ? dayjs(data_plantio).add(5, 'days') : null);
                const DIAS_APOS_PLANTIO = (i.data_inicio && data_plantio) ? dayjs(i.data_inicio).diff(dayjs(data_plantio), 'days') : -1;
                const DIAS_APOS_EMERGENCIA = (i.data_inicio && data_emergencia) ? dayjs(i.data_inicio).diff(data_emergencia, 'days') : -1;
                return {
                    cod: i.cod,
                    descricao: i.descricao,
                    area: Number(i.area),
                    area_executada: Number(i.area_executada),
                    cod_operacao: i.cod_operacao,
                    cod_referencia: i.cod_referencia,
                    nome_atv_vinculada: mapNomeAtividades.get(Number(i.cod_referencia)) ?? '',
                    concluido: i.concluido,
                    dias: Number(i.dias),
                    data_inicio: i.data_inicio ?? null,
                    data_final: i.data_final ?? null,
                    finalidades: i.finalidades,
                    estadios_cultura: i.estadios_cultura,
                    observacao: i.observacao,
                    porcentagem_executada: Number(i.porcentagem_executada),
                    porcentagem_remonte: porcentagem_remonte,
                    tipo_operacao: i.tipo_operacao,
                    tipo_referencia: i.tipo_referencia,
                    tipo_referencia_nome: i.tipo_referencia_nome,
                    insumos: orderBy(insumos, 'ordem', 'asc'),
                    patrimonios: patrimonios,
                    dias_apos_plantio: DIAS_APOS_PLANTIO,
                    dias_apos_emergencia: DIAS_APOS_EMERGENCIA,
                    atv_is_pulverizacao: i.cod_operacao === 101
                }
            });
            const item_talhao = mapTalhoes.get(Number(cod_talhao));
            return {
                cod_talhao: Number(cod_talhao),
                nome_talhao: item_talhao?.nome,
                area: item_talhao?.area,
                lista_atividades: orderBy(lista_atividades, 'data_inicio', 'asc')
            }
        })

        //#region retorno estrutura
        return {
            cod_propriedade: Number(cod_propriedade),
            nome_propriedade: (data_propriedades ?? []).find(i => i.cod === Number(cod_propriedade))?.nome,
            lista_atividades_por_talhao: atividades_por_talhao
        }
    });

    return atividades_por_propriedade ?? []
}
//#endregion

//#region COD MEDIDA INOCULANTE
/**Retorna o código da medida baseado no nome da medida */
export function obterCodMedidaInoculante(medida: string) {
    const medida_lower = medida.toLowerCase();
    if (medida_lower === 'l' || medida_lower === 'l/ha') return 1;
    if (medida_lower === 'ml' || medida_lower === 'ml/ha') return 2;
    if (medida_lower === 'kg' || medida_lower === 'kg/ha') return 3;
    if (medida_lower === 'g' || medida_lower === 'g/ha') return 4;
    if (medida_lower === 'sc' || medida_lower === 'sc/ha') return 5;
    if (medida_lower === 't' || medida_lower === 't/ha') return 7;
    if (medida_lower === '@' || medida_lower === '@/ha') return 8;
    if (medida_lower === 'sementes' || medida_lower === 'sementes/ha') return 9;
    if (medida_lower === '%' || medida_lower === '%/ha') return 10;
    if (medida_lower === 'g/l' || medida_lower === 'g/l/ha') return 11;
    if (medida_lower === 'dose' || medida_lower === 'dose/ha') return 12;
    if (medida_lower === 'g/kg de semente' || medida_lower === 'g/kg de semente/ha') return 16;
    if (medida_lower === 'ml/kg de semente' || medida_lower === 'ml/kg de semente/ha') return 17;
    if (medida_lower === 'l/tanque de pulverização' || medida_lower === 'l/tanque de pulverização/ha') return 18;
    return null;
};